<template>
  <LayoutDefault>
    <section class="education">
      <h1 class="education__title">Образование</h1>
      <div class="education__block"
        v-for="(item, idx) in test"
        :key="idx"
      >
      <div class="education__editor" v-if="item.name == ''">
        <ckeditor
          :editor="editor"
          :config="editorConfig"
          :model-value="item.description"
        />
      </div>
      <table class="education__table">
        <thead>
          <tr>
            <th class="education__table-title">Категория</th>
            <th class="education__table-title">Наполнение</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, idx) in test2" :key="idx">
            <td class="education__categories">
              <p>{{ item.name }}</p>
            </td>
            <td class="education__filling">
              <Textarea
                v-model="item.description"
                autoResize rows="1"
                cols="70"
              />
            </td>
          </tr>
        </tbody>
      </table>
      </div>
      <div class="education__implemented-programs implemented-programs"
        v-for="(item, idx) in test3"
        :key="idx"
      >
        <div class="implemented-programs__table">
          <ImplementedProgramsTable :data="dataSource"/>
        </div>
        <div class="implemented-programs__editor">
          <ckeditor
            :editor="editor"
            :config="editorConfig"
            v-model="item.description"
          />
        </div>
      </div>
      <div class="education__description-programs description-programs"
        v-for="(item, idx) in test4"
        :key="idx"
      >
        <div class="description-programs__table">
          <DescriptionProgramsTable :data="dataSource"/>
        </div>
        <div class="description-programs__editor">
        <ckeditor
          :editor="editor"
          :config="editorConfig"
          v-model="item.description"
        />
      </div>
      </div>
      <div class="education__link">
        <p>Информация о лицензии на осуществление образовательной деятельности</p>
        <span>Licensia2016.pdf</span>
      </div>
    </section>
  </LayoutDefault>
</template>

<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import LayoutDefault from '@/layout/LayoutDefault'
import ImplementedProgramsTable from '@/components/blocks/ImplementedProgramsTable.vue'
import DescriptionProgramsTable from '@/components/blocks/DescriptionProgramsTable.vue'

import Editor from 'ckeditor5-custom-build/build/ckeditor'
import Textarea from 'primevue/textarea'

export default {
  name: 'EducationView',
  components: {
    LayoutDefault,
    Textarea,
    ImplementedProgramsTable,
    DescriptionProgramsTable
  },
  props: {
  },
  setup () {
    const store = useStore()

    const editor = ref(Editor)

    const editorConfig = ref({})

    const test = ref([
      {
        id: 1,
        name: '',
        description: 'а) о реализуемых образовательных программах, в том числе о реализуемых адаптированных образовательных программах, с указанием в отношении каждой образовательной программы: форм обучения; нормативного срока обучения; языка(х), на котором(ых) осуществляется образование (обучение); учебных предметов, курсов, дисциплин (модулей), предусмотренных соответствующей образовательной программой; практики, предусмотренной соответствующей образовательной программой; об использовании при реализации образовательной программы электронного обучения и дистанционных образовательных технологий.'
      }
    ])

    const test2 = ref([
      {
        id: 2,
        name: 'Общая численность обучающихся за 2020 год – 122 чел, из них',
        description: 'за счет бюджетных ассигнований федерального бюджета 0% за счет бюджетов субъектов Российской Федерации 0% за счет местных бюджетов 0% по договорам об оказании платных образовательных услуг 100%'
      },
      {
        id: 3,
        name: 'Уровень образования',
        description: 'К освоению дополнительных профессиональных программ допускаются: Лица, имеющие среднее профессиональное и (или) высшее образование; Лица, получающие среднее профессиональное и (или) высшее образование.'
      }
    ])

    const test3 = ref([
      {
        id: 1,
        description: 'б) об описании образовательной программы с приложением образовательной программы в форме электронного документа или в виде активных ссылок, непосредственный переход по которым позволяет получить доступ к страницам Сайта, содержащим информацию, в том числе:'
      }
    ])

    const test4 = ref([
      {
        id: 1,
        description: 'в) о численности обучающихся, в том числе: Общая численность обучающихся за 2020 год – 122 чел, из них за счет бюджетных ассигнований федерального бюджета 0% за счет бюджетов субъектов Российской Федерации 0% за счет местных бюджетов 0% по договорам об оказании платных образовательных услуг 100% Уровень образования К освоению дополнительных профессиональных программ допускаются: Лица, имеющие среднее профессиональное и (или) высшее образование; Лица, получающие среднее профессиональное и (или) высшее образование. г) о лицензии на осуществление образовательной деятельности (выписке из реестра лицензий на осуществление образовательной деятельности)'
      }
    ])

    const dataSource = computed(() => {
      // данные для отрисовки таблицы
      return store.getters.getNewsDataTable
    })

    return {
      editor,
      editorConfig,
      test,
      test2,
      test3,
      test4,
      dataSource
    }
  }
}
</script>

<style lang="scss" scoped>
.education {
  &__title {
    @include information-block-title;
    margin-bottom: 22px;
  }

  &__block {
    display: flex;
    gap: 135px;
    margin-bottom: 60px;
  }

  &__editor {
    width: 45%;
  }

  &__table {
    text-align: left;

    tr {
      vertical-align: top;
    }
  }

  &__table-title {
    font-size: 18px;
    font-weight: 500;
    padding-bottom: 8px;
  }

  &__categories {
    width: 35%;
    padding-right: 20px;

    p {
      font-size: 14px;
      line-height: 18px;
    }
  }

  &__filling {
    :deep(.p-inputtextarea) {
      margin-bottom: 10px;
      padding: 8px 12px;
      font-size: 14px;
      line-height: 18px;
    }
  }

  &__implemented-programs,
  .implemented-programs {

    &__table {
      margin-bottom: 32px;
    }

    &__editor {
      width: 50%;
      margin-bottom: 95px;
    }
  }

  &__description-programs,
  .description-programs {

    &__table {
      margin-bottom: 32px;
    }

    &__editor {
      width: 50%;
      margin-bottom: 32px;
    }
  }

  &__link {
    display: flex;
    gap: 25px;
    text-align: left;

    p {
      width: 15%;
      font-size: 14px;
    }

    span {
      color: #1BA6DA;
    }
  }
}
</style>
